(() => {
  'use strict';

  const ROOT = '[data-tv-bump]';
  const CHECKBOX = '[data-tv-bump-checkbox]';
  const MESSAGE = '[data-tv-bump-message]';
  const originalFetch = window.fetch.bind(window);

  let checkoutArmed = false;
  let bumpInjected = false;
  let flowExpiresAt = 0;

  function activeRoot() {
    const roots = Array.from(document.querySelectorAll(ROOT));
    return roots.find((el) => el.offsetParent !== null) || roots[0] || null;
  }

  function selectedRoot() {
    const root = activeRoot();
    const checkbox = root?.querySelector(CHECKBOX);
    return checkbox?.checked ? root : null;
  }

  function showMessage(root, text = '') {
    const el = root?.querySelector(MESSAGE);
    if (!el) return;
    el.textContent = text;
    el.hidden = !text;
  }

  function setProcessing(root, state) {
    root?.classList.toggle('is-processing', Boolean(state));
    root?.setAttribute('aria-busy', state ? 'true' : 'false');
  }

  function armCheckoutFlow() {
    const root = selectedRoot();

    if (!root) {
      checkoutArmed = false;
      bumpInjected = false;
      return;
    }

    checkoutArmed = true;
    bumpInjected = false;
    flowExpiresAt = Date.now() + 15000;
    showMessage(root);
  }

  function isGoKwikTrigger(target) {
    if (!(target instanceof Element)) return false;

    return Boolean(
      target.closest('#gokwik-buy-now') ||
      target.closest('[onclick*="startGoKwikFlow"]') ||
      target.closest('[data-gokwik-buy-now]') ||
      target.closest('.gokwik-buy-now')
    );
  }

  async function injectBump(root) {
    if (!root || bumpInjected) return;

    const variantId = Number(root.dataset.bumpVariantId);

    if (!Number.isInteger(variantId) || variantId <= 0) {
      throw new Error('The special-offer product is unavailable.');
    }

    bumpInjected = true;
    setProcessing(root, true);

    const response = await originalFetch(
      `${window.Shopify?.routes?.root || '/'}cart/add.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties: {
              _order_bump: 'true',
              _order_bump_for: String(root.dataset.mainProductId || '')
            }
          }]
        })
      }
    );

    if (!response.ok) {
      bumpInjected = false;

      let message = 'The special offer could not be added.';
      try {
        const data = await response.json();
        message = data.description || data.message || message;
      } catch (_) {}

      throw new Error(message);
    }
  }

  window.fetch = async function tvOrderBumpFetch(input, init = {}) {
    const url = typeof input === 'string' ? input : input?.url || '';
    const method = String(init?.method || 'GET').toUpperCase();
    const root = selectedRoot();

    if (checkoutArmed && Date.now() > flowExpiresAt) {
      checkoutArmed = false;
      bumpInjected = false;
    }

    const isCartClear = url.includes('/cart/clear.js') && method === 'POST';
    const isCartAdd = url.includes('/cart/add.js') && method === 'POST';

    if (checkoutArmed && root && isCartClear) {
      bumpInjected = false;
      return originalFetch(input, init);
    }

    if (checkoutArmed && root && isCartAdd && !bumpInjected) {
      const mainProductResponse = await originalFetch(input, init);

      if (!mainProductResponse.ok) {
        checkoutArmed = false;
        return mainProductResponse;
      }

      try {
        await injectBump(root);
        showMessage(root);
      } catch (error) {
        console.error('[Toysvala Order Bump]', error);
        showMessage(root, error?.message || 'The special offer could not be added.');
      } finally {
        setProcessing(root, false);
        checkoutArmed = false;
      }

      return mainProductResponse;
    }

    return originalFetch(input, init);
  };

  document.addEventListener(
    'click',
    (event) => {
      if (isGoKwikTrigger(event.target)) {
        armCheckoutFlow();
      }
    },
    true
  );

  document.addEventListener('change', (event) => {
    const checkbox = event.target.closest?.(CHECKBOX);
    if (!checkbox) return;

    const root = checkbox.closest(ROOT);
    root?.classList.toggle('is-selected', checkbox.checked);
    showMessage(root);
  });

  function wrapGoKwikForProgrammaticCalls() {
    const fn = window.startGoKwikFlow;

    if (typeof fn !== 'function' || fn.__tvBumpArmed) return;

    function wrapped(...args) {
      armCheckoutFlow();
      return fn.apply(this, args);
    }

    wrapped.__tvBumpArmed = true;
    wrapped.__tvOriginal = fn;
    window.startGoKwikFlow = wrapped;
  }

  wrapGoKwikForProgrammaticCalls();

  const timer = window.setInterval(wrapGoKwikForProgrammaticCalls, 500);
  window.setTimeout(() => window.clearInterval(timer), 30000);
  document.addEventListener('shopify:section:load', wrapGoKwikForProgrammaticCalls);
})();
